import { Typography } from "antd";
import PropTypes from "prop-types";
import { Link } from "react-router";

import { FlexContainerText } from "@/modules/flex-container";
import { StateTag } from "@/modules/state-tag";

const { Text } = Typography;

function versionToString(versionNumber) {
  return `v${versionNumber ? versionNumber : 0}`;
}

import "./Revision.style.less";

const Revision = ({
  label,
  name,
  version,
  state,
  stateType,
  additionalText,
  link,
}) => {
  const content = link ? (
    <Link to={link}>
      <Text className="revison-content-text">
        {state ? <StateTag value={state} type={stateType} /> : ""}
        {name ? <span>{name}</span> : ""}
        <span>{versionToString(version)}</span>
        {additionalText ? <span>{additionalText}</span> : ""}
      </Text>
    </Link>
  ) : (
    <Text className="revison-content-text">
      {state ? <StateTag value={state} type={stateType} /> : ""}
      {name ? <span>{name}</span> : ""}
      <span>{versionToString(version)}</span>
      {additionalText ? <span>{additionalText}</span> : ""}
    </Text>
  );

  return (
    <>
      {label && <FlexContainerText label={label} />}
      <div className="revison-content">{content}</div>
    </>
  );
};

Revision.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  version: PropTypes.number,
  state: PropTypes.string,
  stateType: PropTypes.string,
  additionalText: PropTypes.string,
  link: PropTypes.string,
};

export default Revision;
